<script>
import {mapState} from "vuex";
import {EF_TRACKING_URL} from "@/paths/constants";

export default {
  props: {
    prepare: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      loading: null,
      weight: 150,
      weightString: "150",
    };
  },

  computed: {
    ...mapState([
      "fields",
      "fieldsFromUrl",
      "fieldsFromStorage"
      ]),
  },

  created() {
    if (this.prepare) {
      this.weight = parseInt(this.fieldsFromUrl['weight'])

      if (!(this.weight) === false) {
        this.weight = parseInt(this.fieldsFromUrl['weight'])
      } else if (!(this.fieldsFromStorage['weight'] === undefined)) {
        this.weight = parseInt(this.fieldsFromStorage['weight'])
      }

      if ( !(this.weight > 50 && this.weight < 700) ) {
        this.$emit('show-this-step')
      } else {
        this.setAnswer()
      }
    }
  },

  methods: {
    async setAnswer(answer) {
      this.loading = null
      this.loading = answer;
      this.$store.dispatch("setAnswers", [
        {
          field: "weight",
          value: this.weight,
        },
      ]);
      this.$emit('next-step')
      // await this.progressionTracking();
    },

    async progressionTracking() {
      const eventID = "57"
      await this.axios.post(`${EF_TRACKING_URL}&event_id=${eventID}&transaction_id=${this.fields['transaction_id']}`)
    },

    handleChange() {
      let val = String(this.weight);
      if (val === "400") {
        val = val + "+"
      }
      this.weightString = val
    },
  },
};
</script>

<template>
  <div v-if="!prepare">
    <div class="container is-max-widescreen px-5">
      <div class="has-text-centered item-box">
        <h2 class="question mb-3">
          What is your weight?
        </h2>
        <form
          class="container is-max-widescreen"
          @submit.prevent="setAnswer('Continue')"
        >
          <h2 class="question pt-5">{{ weightString }} lbs.</h2>
          <b-field class="pt-4">
            <b-slider size="is-large" :min="50" :max="400" :step="5" :tooltip="false" v-model="weight" rounded @input="handleChange"></b-slider>
          </b-field>
          <input
            type="submit"
            value="Continue"
            class="submitButton mt-3"
            :loading="loading === 'Continue'"
            :disabled="loading !== null"
          />
        </form>
      </div>
    </div>
  </div>
</template>
